import {StickerType} from 'yougile-model'

export const getStickerClassName = ({
  location,
  hasTransparentStyle,
  className,
  filterValues,
  stickerType,
  isRunningTimer,
  taskIsCompleted,
  menuIsOpened
}: {
  location: string
  hasTransparentStyle?: boolean
  className?: string
  filterValues?: string[]
  stickerType: StickerType
  isRunningTimer: boolean
  taskIsCompleted?: boolean
  menuIsOpened?: boolean
}): string => {
  let result = className || ''

  if (location === 'panel') {
    result = `${result} outline-1 ${
      filterValues?.length ? 'outline-2 -outline-offset-2 hover:outline-2' : ''
    }`
  }

  if (
    location === 'task' &&
    ['deadline', 'timer', 'stopwatch'].includes(stickerType)
  ) {
    result = `${result} ${isRunningTimer ? 'min-w-[80px]' : ''}`
  }

  if (hasTransparentStyle) {
    result = `${result} outline-1 ${
      taskIsCompleted
        ? `${
            menuIsOpened ? 'opacity-[.64]' : 'opacity-[.38]'
          } hover:opacity-[.64]`
        : `${menuIsOpened ? 'opacity-100' : 'opacity-[.64]'} hover:opacity-100`
    }`
  }

  return result
}
